import { t } from "ttag";

import NoResults from "assets/img/no_results.svg";
import Tooltip from "metabase/core/components/Tooltip";

import { Root, ShortMessage } from "./NoResultsView.styled";

import {t as customT} from "i18next"

interface NoResultsViewProps {
  isSmall?: boolean;
}

function NoResultsView({ isSmall }: NoResultsViewProps) {
  return (
    <Root>
      <Tooltip tooltip={customT('metabase_no_result')} isEnabled={isSmall}>
        <img data-testid="no-results-image" src={NoResults} />
      </Tooltip>
      {!isSmall && <ShortMessage>{customT('metabase_no_result')}</ShortMessage>}
    </Root>
  );
}

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default NoResultsView;
